import http from '@axios'

const ENDPOINT = 'public.cfc?method=getHomepageContentById'

function getField(record, fieldName) {
  // ensure page works with either titlestandard or TITLESTANDARD.
  if (record[fieldName] !== null && record[fieldName] !== undefined) {
    return record[fieldName]
  }

  const upperCaseFieldName = fieldName.toUpperCase()
  if (record[upperCaseFieldName] !== null && record[upperCaseFieldName] !== undefined) {
    return record[upperCaseFieldName]
  }

  return ''
}

function chooseContent(standardValue, premiumValue, isPremium) {
  const premiumValueHasContent = premiumValue !== null
    && premiumValue !== undefined
    && String(premiumValue).trim() !== ''

  // Premium users only see premium copy when that copy has actually been filled in.otherwise show standard content
  if (isPremium && premiumValueHasContent) {
    return premiumValue
  }

  return standardValue || ''
}

export function toHomepageContentViewModel(record, isPremium) {
  if (!record) {
    return {
      title: '',
      htmlContent: '',
    }
  }

  const titleStandard = getField(record, 'titlestandard')
  const titlePremium = getField(record, 'titlepremium')
  const htmlContentStandard = getField(record, 'htmlcontentstandard')
  const htmlContentPremium = getField(record, 'htmlcontentpremium')

  return {
    title: chooseContent(titleStandard, titlePremium, isPremium),
    htmlContent: chooseContent(htmlContentStandard, htmlContentPremium, isPremium),
  }
}

export function getHomepageContentById(id) {
  return http.get(ENDPOINT, {
    params: {
      id,
    },
  })
    .then(response => {
      const record = response.data

      if (!record) {
        return record
      }

      const success = record.success !== null && record.success !== undefined
        ? record.success
        : record.SUCCESS

      if (success === false) {
        return null
      }

      return record
    })
}
